import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import DataTable, { DATA_TABLE_TYPES } from "../../components/Table/DataTable";
import ReportsService from "../../services/reports.service";
import { DATA_TABLE_FILTER } from "../../components/Table/FilterPopup";
import { ByteDisplay } from "../../components/General/ByteDisplay";
import { TimeDisplay } from "../../components/General/TimeDisplay";
import ChannelsService from "../../services/channels.service";
import { DataLoading } from "../../components/PreLoader/PreLoader";
import moment from "jalali-moment";
import { ROUTES } from "../../services/constants";
import { uid } from "../../helper";
import twemoji from "twemoji";
import { CountryInfo } from "./CountryInfo";
import { IP } from "./IP";
import { Browser } from "./Browser";
const Monitoring = ({}) => {
    const {t} = useTranslation();
    const {setPageTitle} = useOutletContext();
    const [channels, setChannels] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        ChannelsService.listAsOptions().then((data) => {
            setChannels(data);
            setIsLoading(false);
        })
    }, [])

    let defaultFilterConfig = {
        date: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    };
    
    const columns = [
        { 
            key: "id",
            label: "#"
        },
        { 
            key: "date", 
            label: t("Date"), 
            filter: DATA_TABLE_FILTER.DATE_RANGE,
            forceFilter: true,
            type: DATA_TABLE_TYPES.REPORT_DATE,
            sort: true
        },
        { 
            key: "uid", 
            label: t("Account Number"), 
            render: (row) => uid(row.uid), 
            filter: DATA_TABLE_FILTER.INPUT,
            sort: true,
            to: (row) => (`${ROUTES.ACCOUNT_DASHBOARD.replace(':uid', row.uid)}`)
        },
        { 
            key: "channel_id", 
            label: t("Channel"),
            filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
            options: channels
        },
        { 
            key: "country_name", 
            label: t("Country/City"),
            render: (row) => <CountryInfo row={row} />, 
        },
        { 
            key: "device", 
            label: t("Device"),
            render: (row) => {
                console.log(row)
                return (
                    <>
                        <IP row={row} />
                        <Browser row={row} />
                    </>
                )
            }, 
            
        },
        { 
            key: "total_bytes", 
            label: t("Downloaded"), 
            render: (row) => {
                return (
                    <>
                        <TimeDisplay seconds={row.total_downloaded_seconds} /><br/>
                        <ByteDisplay bytes={row.total_bytes} />
                    </>
                )
            },
            sort: true
        },
        { 
            key: "total_watched_bytes", 
            label: t("Watched/Listened"),
            render: (row) => {
                return (
                    <>
                        <TimeDisplay seconds={row.total_watched_seconds} /><br/>
                        <ByteDisplay bytes={row.total_watched_bytes} />
                    </>
                )
            },
            sort: true
        }
        
    ]
    useEffect(() => { 
        setPageTitle(t("Yearly and monthly overview"));
    }, [setPageTitle]);
    return (
        <>
            {isLoading?(
                <DataLoading small={true} />
            ):(
                <DataTable 
                    columns={columns} 
                    fetcher={ReportsService.monitor}
                    searchPlaceholder={t("Search by Account Number or Customer Name or E-Mail...")}
                    defaultPageSize={31}
                    defaultSortKey={"date"}
                    customFilters={[{
                        key: "uid", 
                        label: t("Account Number"), 
                        filter: DATA_TABLE_FILTER.INPUT,
                    },{
                        key: "ip", 
                        label: t("IP Address"), 
                        filter: DATA_TABLE_FILTER.INPUT,
                    }, { 
                        key: "channel_id", 
                        label: t("Channel"),
                        filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
                        options: channels
                    }, { 
                        key: "quality", 
                        label: t("Quality"),
                        filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
                        options: [
                            { key: "1080", value: "1080" }, 
                            { key: "720", value: "720" }, 
                            { key: "480", value: "480" },
                            { key: "360", value: "360" },
                            { key: "288", value: "288" },
                            { key: "180", value: "180" }
                        ]
                    }]}
                    defaultFilterConfig={defaultFilterConfig}
                    autoReload={true}
                />
            )}
            
        </>
    )
}
export default Monitoring;